import { DropOver, MentionInputSuggestionBoxHandle } from "client/Components";
import { MentionSuggestionBox, MentionSuggestionBoxProps } from "./MentionSuggestionBox";
import {
	ReactElement,
	Ref,
	forwardRef
} from "react";
import { Rect } from "client/Misc/commonTypes";
import { isNotNil } from "client/Misc/utils";

export type DropOverMentionSuggestionBoxProps = MentionSuggestionBoxProps & {
	target: HTMLElement;
	onClose: () => void;
	rect?: Rect;
};

export const DropOverMentionSuggestionBox = forwardRef(
	(props: DropOverMentionSuggestionBoxProps, ref: Ref<MentionInputSuggestionBoxHandle>): ReactElement => {
		const {
			target,
			onClose,
			rect,
			...otherProps
		} = props;

		return (
			<DropOver
				target={target}
				hasResponsiveDropOver={false}
				onClose={onClose}
				targetAlignment={
					isNotNil(rect)
						? {
							kind: "rect",
							rect: rect,
							alignment: "bl"
						}
						: "bl"
				}
				contentAlignment="tl"
			>
				<MentionSuggestionBox
					{...otherProps}
					ref={ref}
					variant="dropover"
				/>
			</DropOver>
		);
	}
);
DropOverMentionSuggestionBox.displayName = "DropOverMentionSuggestionBox";
